import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import { handleGovPayCancel, updateRenewToCanceledAtGovpay } from 'util/APIUtils';
import LoadingIndicator from 'components/LoadingIndicator';

const CanceledCheckout = ({ enqueueSnackbar }) => {
  const [lastLocationAndState] = useState(handleGovPayCancel());
  const [nextLocationAndState, setNextLocationAndState] = useState(null);

  useEffect(() => {
    const { state } = lastLocationAndState;
    // console.log("hit it", lastLocationAndState);
    if (state && state.renewal && state.renewal.id) {
      updateRenewToCanceledAtGovpay(state.renewal.id)
        .then(updatedRenewal => {
          // console.log("received updatedRenewal", {...lastLocationAndState, state: {...state, renewal: updatedRenewal}});
          setNextLocationAndState({ ...lastLocationAndState, state: { ...state, renewal: updatedRenewal } });
        }).catch(error =>
          enqueueSnackbar((error && error.message) || 'Oops! Something went wrong. Please try again!', { variant: 'error' }));
    } else {
      setNextLocationAndState(lastLocationAndState);
    }
  }, [lastLocationAndState, enqueueSnackbar]);

  if (!nextLocationAndState) {
    return <LoadingIndicator />
  }

  return <Redirect to={nextLocationAndState} />;
};

export default withSnackbar(CanceledCheckout);
